export default __webpack_public_path__ + "static/media/ico_credit_card.2201ace8.svg";